import { Link } from 'react-router-dom'
import { CheckCircle2, ArrowRight, Mail } from 'lucide-react'
import Button from '../components/ui/Button'
import SEO from '../components/SEO'

export default function PaymentSuccess() {
  return (
    <div className="min-h-screen flex items-center justify-center px-4 pt-8 pb-16">
      <SEO title="Payment Successful" description="" path="/payment/success" noindex />
      <div className="max-w-md w-full text-center">
        <div className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6" style={{ background: 'color-mix(in srgb, var(--accent) 15%, transparent)', border: '1px solid color-mix(in srgb, var(--accent) 30%, transparent)' }}>
          <CheckCircle2 size={40} className="text-accent" />
        </div>

        <h1 className="text-3xl font-display font-bold text-ink mb-3">Payment received!</h1>
        <p className="text-[var(--ink-soft)] leading-relaxed mb-8">
          Thank you for choosing MySchoolPortal. Our team will reach out within{' '}
          <span className="text-ink font-semibold">24 hours</span>{' '}
          to set up your account and walk you through getting started.
        </p>

        <div className="rounded p-5 mb-8 text-left space-y-4 bg-surface border border-theme">
          {[
            { step: '1', label: 'Account setup',   desc: 'We create your school workspace and configure your chosen modules.' },
            { step: '2', label: 'Data import',      desc: 'Send us your student list and we import it for you.' },
            { step: '3', label: 'Staff training',   desc: "A 30-minute walkthrough for your team, live or recorded." },
            { step: '4', label: 'You go live',      desc: 'Start using MySchoolPortal from day one, fully supported.' },
          ].map(s => (
            <div key={s.step} className="flex items-start gap-3">
              <div className="w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0 mt-0.5 text-accent" style={{ background: 'color-mix(in srgb, var(--accent) 12%, transparent)', border: '1px solid color-mix(in srgb, var(--accent) 25%, transparent)' }}>
                {s.step}
              </div>
              <div>
                <p className="text-sm font-semibold text-ink">{s.label}</p>
                <p className="text-xs text-[var(--ink-soft)]">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="flex items-center gap-2 justify-center text-sm text-[var(--ink-soft)] mb-8">
          <Mail size={14} />
          <span>Questions? Email us at <a href="mailto:info@myschoolportal.xyz" className="text-accent">info@myschoolportal.xyz</a></span>
        </div>

        <Link to="/">
          <Button variant="primary" size="lg">Back to Home <ArrowRight size={16} /></Button>
        </Link>
      </div>
    </div>
  )
}
